import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login.component';
import { IniciarSesionComponent } from './iniciar-sesion/iniciar-sesion.component';
import { RegistroComponent } from './registro/registro.component';
import { VerifyEmailComponent } from './verify-email/verify-email.component';
import { VerifyCodeComponent } from './verify-code/verify-code.component';


const routes: Routes = [
  {
    path: '', component: LoginComponent,
    children: [
        { path: '', component: IniciarSesionComponent },
        { path: 'registro', component: RegistroComponent },
        { path: 'verify-email', component: VerifyEmailComponent },
        { path: 'verify-code', component: VerifyCodeComponent },
        { path: 'registro/:id', component: RegistroComponent }
    ]
}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LoginRoutingModule { }
